import React, { useState } from "react";
import "../styles/components/DownloadFormatModal.css";

const DownloadFormatModal = ({
  isOpen,
  onClose,
  onDownload,
  downloadFormats = [],
}) => {
  const [selectedFormats, setSelectedFormats] = useState([]);

  const handleFormatSelection = (format) => {
    if (selectedFormats.includes(format)) {
      setSelectedFormats(selectedFormats.filter((f) => f !== format));
    } else {
      setSelectedFormats([...selectedFormats, format]);
    }
  };

  const handleDownload = () => {
    onDownload(selectedFormats);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="download-format-modal-overlay">
      <div className="download-format-modal-container">
        <div className="download-format-modal-header">
          <h2>Select Download Formats</h2>
          <button className="download-format-modal-close" onClick={onClose}>
            &times;
          </button>
        </div>
        <div className="download-format-modal-content">
          {downloadFormats.includes("excel") && (
            <label className="custom-checkbox-container">
              <input
                type="checkbox"
                checked={selectedFormats.includes("excel")}
                onChange={() => handleFormatSelection("excel")}
              />
              <span className="custom-checkbox-checkmark"></span>
              EXCEL
            </label>
          )}
          {downloadFormats.includes("pdf") && (
            <label className="custom-checkbox-container">
              <input
                type="checkbox"
                checked={selectedFormats.includes("pdf")}
                onChange={() => handleFormatSelection("pdf")}
              />
              <span className="custom-checkbox-checkmark"></span>
              PDF
            </label>
          )}
          {downloadFormats.includes("full-page-pdf") && (
            <label className="custom-checkbox-container">
              <input
                type="checkbox"
                checked={selectedFormats.includes("full-page-pdf")}
                onChange={() => handleFormatSelection("full-page-pdf")}
              />
              <span className="custom-checkbox-checkmark"></span>
              FULL PAGE PDF
            </label>
          )}
        </div>
        <div className="download-format-modal-actions">
          <button className="download-format-modal-cancel" onClick={onClose}>
            Cancel
          </button>
          <button
            className="download-format-modal-confirm"
            onClick={handleDownload}
            disabled={selectedFormats.length === 0}
          >
            Download
          </button>
        </div>
      </div>
    </div>
  );
};

export default DownloadFormatModal;
